
/**
 * KEINEN SERVICE WORKER STARTEN
 * ersetzt sw-register.ts
 */

/**
 * dummy
 **/
export function startServiceWorker() {
	// nothing to do
}

/**
 * dummy
 **/
export function	updateServiceWorker( url? : string ) {
	// nothing to do
}
